module.exports = __webpack_public_path__ + "static/img/Christian_Petracca_desktop.b44eb6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Christian_Petracca_desktop.jpg
// module id = /2wj
// module chunks = 0